import React, { useEffect, useState, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import '../Style/Industries.css';

gsap.registerPlugin(ScrollTrigger);

const images = [
  
  '/carsole 1.webp',
  '/carsole2.jpg',
  '/carsole3.webp',
  '/download (1).jpeg',
  '/carsole4.webp',

];

const Industries = () => {
  const [startIndex, setStartIndex] = useState(0);
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const carouselRef = useRef(null);
  const cardsRef = useRef([]);

  // Auto-slide 1-by-1 every 2 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setStartIndex((prev) => (prev + 1) % images.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  // Scroll-triggered animations that replay on each scroll
  useEffect(() => {
    const ctx = gsap.context(() => {
      // Title animation - replays on scroll
      gsap.fromTo(titleRef.current,
        { y: 50, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 80%',
            toggleActions: 'play none none none'
          }
        }
      );

      // Carousel animation - replays on scroll
      gsap.fromTo(carouselRef.current,
        { y: 30, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.8,
          delay: 0.3,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 75%',
            toggleActions: 'play none none none'
          }
        }
      );

      // Continuous hover animation for carousel cards
      cardsRef.current.forEach((card, index) => {
        if (card) {
          gsap.to(card, {
            y: -10,
            duration: 0.5,
            repeat: -1,
            yoyo: true,
            ease: 'power1.inOut',
            delay: index * 0.1
          });
        }
      });
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  const addToRefs = (el) => {
    if (el && !cardsRef.current.includes(el)) {
      cardsRef.current.push(el);
    }
  };

  // Get 4 images starting from current index, wrapped using modulus
  const getVisibleImages = () => {
    let result = [];
    for (let i = 0; i < 4; i++) {
      result.push(images[(startIndex + i) % images.length]);
    }
    return result;
  };

  const visibleImages = getVisibleImages();

  return (
    <div className="industries-container" ref={sectionRef}>
      <h1 ref={titleRef}>Industries We Serve</h1>
       <img src="/buzz.png" alt="Contact Us" className='contact-img'/>
      <div className="carousel-wrapper" ref={carouselRef}>
        <button onClick={() =>
          setStartIndex((prev) => (prev - 1 + images.length) % images.length)
        } className="nav-button">‹</button>

        <div className="carousel">
          {visibleImages.map((img, idx) => (
            <div
              key={idx}
              ref={addToRefs}
              className={`carousel-item ${idx === 1 || idx === 2 ? 'straight' : 'tilted'}`}
            >
              <img src={img} alt={`Industry ${idx + 1}`} />
            </div>
          ))}
        </div>

        <button onClick={() =>
          setStartIndex((prev) => (prev + 1) % images.length)
        } className="nav-button">›</button>
      </div>
    </div>
  );
};

export default Industries;
